export default __webpack_public_path__ + "static/media/Step-02.336d580f.jpg";